export class IntentEnum {
    static CompareNorms = 'CompareNorms';
    static SendQuestion = 'SendQuestion';
    static FreeQuestion = 'FreeQuestion';
}